import { Button, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'


const CustomDownloadLink = ({ href, download, icon, title }) => {
    return (
        <a href={href} download={download} className='custom-link'>
            <Stack alignItems="center" direction="row" gap={0.5}>
                {icon}
                <Typography>{title}</Typography>
            </Stack>
        </a>
    )
}

export default CustomDownloadLink